export interface FlightGetRecord {
  flightNo: string;
  dayOfOrigin: string;
  dayOfOriginString: string;
  callSign: string;
  legNumber: number;
  registration: string;
  subtype: string;
  flightCaptain: string;
  schDepAirport: string;
  schDepDatetime: string;
  schDepDatetimeString: string;
  schArrAirport: string;
  schArrDatetime: string;
  schArrDatetimeString: string;
  actDepAirport: string;
  actDepDatetime: string;
  actDepDatetimeString: string;
  actArrAirport: string;
  actArrDatetime: string;
  actArrDatetimeString: string;
  carrierCode: string;
  flightNumber: number;
}
